import React, { useState, useEffect, useRef } from 'react'
import { useLocation, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";

import { CheckoutProgress } from '../CheckoutProgress';
import { useCart } from '../../contexts/CartContext';
import { useOrder } from '../../contexts/OrderContext';
import ApiHooks from '../../hooks/ApiHooks'
import { ResultMessage } from './ResultMessage'
import { DeliveryDetail } from './DeliveryDetail'
import { CartDetail } from './CartDetail'
import { CartTotal } from './CartTotal';
import { OrderDetail } from './OrderDetail'
import { FixedHeader, GobackTitle } from '../Layout/FixedHeader';
import { Button } from '../Shared/Buttons';
import { FixedFooter } from '../Layout/FixedFooter';

import {
  ConfirmContainer,
  MainContent
} from './styles';

export const Confirm = () => {

  const currentLng = localStorage.getItem('i18nextLng');
  const payment_response = 'payment_response'
  const { t } = useTranslation();
  const history = useHistory();
  const { search } = useLocation();
  const [result, setResult] = useState(null)
  const _param = search.split('=')
  const [cart, { initCart }] = useCart();
  const [orderDetail, { initOrder, updateOrder }] = useOrder();
  const paymentStatusInCash = orderDetail?.orderInfo
  const cartClearedRef = useRef(false)
  const [paymentStatus] = ApiHooks(`/${payment_response}/${_param[1] || ''}`, {}, 'GET', (_param[1] !== 'cashpay' && _param[1] !== '' && _param[1]))

  const goHome = () => {
    initOrder();
    history.push('/home');
  }

  const clearCartAfterSuccess = () => {
    if (cartClearedRef.current) return
    cartClearedRef.current = true
    if (cart.length) updateOrder({ orderCart: cart })
    initCart()
  }

  useEffect(() => {
    if (paymentStatusInCash?.method === 0) {
      setResult(paymentStatusInCash)
      clearCartAfterSuccess()
      return
    }
    if (!paymentStatus?.loading && paymentStatus?.result && !paymentStatus?.result?.data?.response?.data) {
      history.push('failure')
      return
    }
    if (!paymentStatus?.loading && paymentStatus?.result?.success) {
      setResult(paymentStatus?.result?.data?.response?.data)
      clearCartAfterSuccess()
    }
  }, [paymentStatus, paymentStatusInCash])

  useEffect(() => {
    if (_param[0].replace(/\?/g, '') !== 'data' || (_param[1] === '' || !_param[1])) {
      history.push('failure')
    }
  }, [_param])

  return (
    <>
      {result ? (
        <ConfirmContainer>
          <FixedHeader>
            {currentLng === 'en'
              ? <FiArrowLeft size="20" onClick={goHome} />
              : <FiArrowRight size="20" onClick={goHome} />
            }
            <GobackTitle dir="ltr"><span>#{result?.variable1}</span></GobackTitle>
          </FixedHeader>
          <CheckoutProgress step={4} />
          <MainContent>
            <ResultMessage res={paymentStatusInCash?.method !== 0 ? paymentStatus?.result?.success : true} />
            <CartDetail />
            <DeliveryDetail />
            <CartTotal paymentStatus={result} cashPay={paymentStatusInCash?.method !== 0} />
            {paymentStatusInCash?.method !== 0 && <OrderDetail paymentStatus={result} />}
          </MainContent>

          <FixedFooter>
            <Button color="primary" width="100%" onClick={goHome}>
              {t('Go Home')}
            </Button>
          </FixedFooter>

        </ConfirmContainer>
      ) : (
        <ConfirmContainer />
      )}
    </>
  )
}
